import { render } from "./iconMenu.vue?vue&type=template&id=cc8fbff8"
import script from "./iconMenu.vue?vue&type=script&lang=js"
export * from "./iconMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__